// 配對只在已登入的 Aiiwu 網頁確認；工具憑證不會交給瀏覽器。
const panel = document.querySelector("[data-portal-connector]")

if (panel) {
  const find = (name) => panel.querySelector(`[data-connector-${name}]`)
  const status = find("status")
  const error = find("error")
  const pair = find("pair")
  const approve = find("approve")
  const revoke = find("revoke")
  let state = null
  let pairingId = null
  let checkCode = null
  let busy = false
  let polling = false
  let revision = 0

  const request = async (url, method = "GET", data = {}) => {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    const response = await fetch(url, {
      method, credentials: "same-origin", signal: AbortSignal.timeout(10000),
      headers: { Accept: "application/json", "Content-Type": "application/json", ...(csrf ? { "X-CSRF-Token": csrf } : {}) },
      ...(method === "GET" ? {} : { body: JSON.stringify(data) })
    })
    if (!response.headers.get("content-type")?.includes("application/json")) throw new Error("請重新登入 Aiiwu 後再連接工具。")
    const body = await response.json()
    if (!response.ok) throw new Error(body.error || "連線工具服務暫時無法使用。")
    return body
  }

  const render = (data) => {
    const connected = ["connected", "busy"].includes(data.state)
    panel.dataset.connected = String(connected)
    status.textContent = {
      offline: "尚未連接，請產生配對碼並在電腦工具輸入。",
      pairing: "等待電腦工具輸入配對碼。",
      pending: "工具已送出配對要求，請核對下方數字。",
      connected: "已連接本機工具，可以取得驗證碼。",
      busy: "正在處理登入或匯入，請保持電腦工具連線。"
    }[data.state] || "正在確認連線…"
    pairingId = data.pairing_id
    checkCode = data.check_code
    find("confirmation").hidden = data.state !== "pending"
    find("check").textContent = checkCode || ""
    approve.hidden = data.state !== "pending"
    revoke.hidden = !connected && data.state !== "pending"
    revoke.textContent = data.state === "busy" ? "中斷連線並停止本次匯入" : "中斷連線"
    pair.hidden = connected
    if (connected || data.state === "offline") find("pairing").hidden = true
    if (state !== data.state) {
      document.dispatchEvent(new CustomEvent("portal-connector:state", { detail: { connected } }))
      state = data.state
    }
  }

  const poll = async () => {
    if (busy || polling) return
    polling = true
    const currentRevision = revision
    try {
      const data = await request(panel.dataset.statusUrl)
      if (currentRevision !== revision) return
      render(data)
      error.hidden = true
    } catch (exception) {
      if (currentRevision !== revision) return
      render({ state: "offline" })
      error.textContent = exception.message
      error.hidden = false
    } finally {
      polling = false
    }
  }

  const act = async (callback) => {
    if (busy) return
    busy = true
    revision += 1
    pair.disabled = approve.disabled = revoke.disabled = true
    error.hidden = true
    try {
      await callback()
    } catch (exception) {
      error.textContent = exception.message
      error.hidden = false
    } finally {
      busy = false
      pair.disabled = approve.disabled = revoke.disabled = false
    }
  }

  pair.addEventListener("click", () => act(async () => {
    const data = await request(panel.dataset.pairUrl, "POST")
    render({ state: "pairing", pairing_id: data.pairing_id })
    find("code").textContent = data.pairing_code
    find("pairing").hidden = false
  }))
  approve.addEventListener("click", () => act(async () => {
    await request(`${panel.dataset.pairUrl}/${encodeURIComponent(pairingId)}/approve`, "POST", { check_code: checkCode })
    status.textContent = "正在完成連接…"
  }))
  revoke.addEventListener("click", () => act(async () => {
    await request(panel.dataset.revokeUrl, "DELETE")
    render({ state: "offline" })
  }))

  poll()
  const timer = setInterval(poll, 3000)
  window.addEventListener("pagehide", () => clearInterval(timer), { once: true })
}
